import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-be-prepared-for-the-unexpected',
  templateUrl: './be-prepared-for-the-unexpected.component.html',
  imports: [UpsellCardComponent],
})
export class BePreparedForTheUnexpectedComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.Levonorgestrel;
}
